import 'css-chunksrc/client/scenes/calendarHolidaysRemoval/styles.scss';export default {
  "header": "_header_1bi54_1",
  "main": "_main_1bi54_5",
  "group": "_group_1bi54_12",
  "text": "_text_1bi54_16",
  "buttons": "_buttons_1bi54_21"
};